import api from "@services/api-service";
import queryParams from "@services/repository-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    data: [],
    links: {},
    meta: {}
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    RESET_PARCEIROS: state => {
      state.parceiros.loading = false;
    },

    SET_PARCEIROS_LOADING: (state, loading) => {
      state.parceiros.loading = loading;
    },

    SET_PARCEIROS: (state, { data, links, meta }) => {
      state.parceiros.data = data;
      state.parceiros.links = links;
      state.parceiros.meta = meta;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    fetchTodosParceiros: () => () =>
      new Promise((resolve, reject) => {
        api()
          .get(`parceiros/todos`)
          .then(response => {
            if (response.data.status) {
              resolve(response.data.data);
            }

            reject(response);
          });
      }),

    isParceirosLoading: state => () => {
      return state.parceiros.loading;
    },

    getParceiros: state => (id, entidade) => {
      let parceiros = state.parceiros.data.filter(parceiro => {
        if (entidade) {
          return parceiro.entidade_id === entidade.id;
        }
        return true;
      });

      if (id) {
        let parceiro = parceiros.filter(parceiro => parceiro.id == id);

        return parceiro.length > 0 ? parceiro[0] : null;
      }

      return parceiros;
    },

    getParceirosMeta: state => () => {
      return state.parceiros.meta;
    },

    getParceirosLinks: state => () => {
      return state.parceiros.links;
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_PARCEIROS(
      { commit, state },
      { page, parceiro, entidade, sortedBy, orderBy }
    ) {
      // Se ja esta buscando
      if (state.parceiros.loading) return;
      commit("SET_PARCEIROS_LOADING", true);
      api()
        .get(`parceiros`, {
          params: queryParams({
            page: page,
            relationships: ["entidade"],
            where: [
              ["nome", "like", parceiro],
              ["entidade_id", "=", entidade]
            ],
            sortedBy: sortedBy,
            orderBy: orderBy
          })
        })
        .then(response => {
          if (response.data.status) {
            commit("SET_PARCEIROS", response.data);
          }
        })
        // .catch(error => {})
        .finally(() => commit("SET_PARCEIROS_LOADING", false));
    },

    FETCH_PARCEIROS_SELECT({ commit }) {
      api()
        .get(`parceiros`)
        .then(response => {
          if (response.data.status) {
            commit("SET_PARCEIROS", response.data);
          }
        });
    },

    FETCH_PARCEIRO({ commit }, parceiro_id) {
      api()
        .get(`parceiros${parceiro_id}`)
        .then(response => {
          if (response.data.status) {
            commit("SET_PARCEIRO", response.data);
          }
        })
        // .catch(error => {})
        .finally(() => commit("SET_PARCEIROS_LOADING", false));
    },

    UPDATE_PARCEIRO_ASYNC({ commit }, parceiro) {
      return new Promise((resolve, reject) => {
        api()
          .patch(`parceiros/${parceiro.id}`, parceiro)
          .then(response => {
            if (response.data.status) {
              commit("UPDATE_STATE_PARCEIRO", parceiro);
              resolve(response.data);
            }
          })
          .catch(error => reject(error));
      });
    },

    SAVE_PARCEIRO: function({ commit }, parceiro) {
      return new Promise((resolve, reject) => {
        api()
          .post(`parceiros`, parceiro)
          .then(response => {
            if (response.data.status) resolve(response.data);
          })
          .catch(error => reject(error));
      });
    },

    RESET_PARCEIROS({ commit }) {
      commit("RESET_PARCEIROS");
    }
  }
};

export default store;
